import { Injectable } from '@angular/core';
import { ApiHelperService, ApiService } from 'app/shared';
import { catchError, map, Observable, throwError } from 'rxjs';
import { NotificationModel } from '../models/notification.model';
import { HttpErrorResponse } from '@angular/common/http';
import { UserNotificationPreferenceModel } from 'app/internal/user-settings/models/user-notification-preference.model';

@Injectable()
export class NotificationsService {

  endpointUrl: string;

  constructor(
    private api: ApiService,
    { notificationServiceUrl }: ApiHelperService
  ) {
    this.endpointUrl = `${notificationServiceUrl}/api/notification`;
  }

  getUserNotificationsByProperty(propertyId: string): Observable<NotificationModel[]> {
    return this.api.get(`${this.endpointUrl}/user?propertyId=${propertyId}`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error))
    );
  }

  setAllUserNotificationsAsRead(propertyId: string): Observable<NotificationModel[]> {
    return this.api.get(`${this.endpointUrl}/user/set-all-as-read?propertyId=${propertyId}`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error))
    );
  }

  getUserNotificationsPreferences(): Observable<UserNotificationPreferenceModel> {
    return this.api.get(`${this.endpointUrl}/user/notification-preferences`).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error))
    );
  }

  updateUserNotificationsPreferences(preferences: UserNotificationPreferenceModel): Observable<boolean> {
    return this.api.put(`${this.endpointUrl}/user/notification-preferences`, preferences).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error))
    );
  }

  private handleError(response: HttpErrorResponse) {
    return throwError(response?.error?.errors);
  }
}
